/**
 * createArFormulaEngineConfig
 *
 * Resolves an ArTable type document into the engine config consumed by
 * computeArRowFormulas. Centralizes the `bundlesEnabled` derivation
 * (groups on, or kits enabled) so no consumer re-derives it — a wrong
 * derivation silently re-enables formulas on bundle-header rows.
 * Accepts a Pick so server callers holding raw `doc.data()` need no cast.
 */

import type { ArFormulaEntry, ArTableType } from '../System.Artifacts.types';

export type ArFormulaEngineConfig = {
  formulaSequence: ArFormulaEntry[];
  bundlesEnabled: boolean;
};

function createArFormulaEngineConfig(
  schema: Pick<ArTableType, 'formulaSequence' | 'bundles'> | undefined,
): ArFormulaEngineConfig {
  return {
    formulaSequence: schema?.formulaSequence ?? [],
    bundlesEnabled:
      schema?.bundles?.groups === true || schema?.bundles?.kits?.enabled === true,
  };
}

export { createArFormulaEngineConfig };
